var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LineageTask_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { lineageTaskSchemaValidation } from '../validations.generated';
export var LineageTaskType;
(function (LineageTaskType) {
    LineageTaskType["REGEN_SUBGRAPH"] = "regen-subgraph";
    LineageTaskType["REMOVE_PIPE_VERTEX"] = "remove-pipe-vertex";
})(LineageTaskType || (LineageTaskType = {}));
export const lineageTaskSchema = {
    $id: 'urn:wisepipe-common-pipe:LineageTask',
    type: 'object',
    properties: {
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        taskType: { type: 'string', enum: Object.values(LineageTaskType) }
    },
    required: ['orgID', 'pipeID', 'taskType']
};
// task object for sqs task queue when regenerating subgraph
// can refactor this to have child task types if we have other lineage tasks
let LineageTask = LineageTask_1 = class LineageTask {
    constructor(orgID, pipeID, taskType) {
        this.orgID = orgID;
        this.pipeID = pipeID;
        this.taskType = taskType;
        JSON.validate(this, LineageTask_1);
    }
};
LineageTask = LineageTask_1 = __decorate([
    JsonSchemaV2(lineageTaskSchema, lineageTaskSchemaValidation)
], LineageTask);
export { LineageTask };
//# sourceMappingURL=lineageTask.js.map